import { supabase } from '../utils/supabaseClient'
import {PersonFull} from "../types/personTypes";

const fetchPersonsFull = async (id: bigint): Promise<PersonFull | null> => {
	try {
		console.log(`Fetching person data for ID: ${id}...`)
		// Step 1: Fetch Person Data
		const { data: personData, error: personError } = await supabase
			.from('persona_page_full')
			.select('*')
			.eq('id', id)
			.single()

		if (personError) {
			console.error('Person Error:', personError)
			throw personError
		}

		console.log('Person Data (Full):', personData)

		// Ensure that the data is correctly typed as PersonFull
		return personData as PersonFull
	} catch (error) {
		console.error('Error fetching persons:', error)
		throw error
	}
}

export default fetchPersonsFull
